export default "__VITE_ASSET__CStj3Tww__"